import {useEffect, useState, useMemo} from 'react';
import {Account, UseNavigatorReturn} from './Navigator.type';
import {NavigatorMap} from './Navigator.map';
import {NavigatorService} from './Navigator.service';

export function useNavigator(account: Account): UseNavigatorReturn {
  const [activeItem, setActiveItem] = useState<string>('');
  const pathName = window.location.pathname;

  // Detectar se há tema configurado
  const hasTheme = useMemo(() => NavigatorService.hasTheme(account), [account]);

  // Detectar item ativo baseado na URL atual
  useEffect(() => {
    const activeFeature = NavigatorMap.getActiveFeatureFromPath(
      pathName,
      account,
    );
    if (activeFeature) {
      setActiveItem(activeFeature);
    }
  }, [pathName, account]);

  // Abrir/fechar submenu
  const openSubmenu = (event: React.MouseEvent, feature: string) => {
    event.preventDefault();

    if (feature !== activeItem) {
      setActiveItem(feature);
    } else {
      setActiveItem('');
    }
  };

  // Toggle da classe ativo para animações
  const toggleAtivoClass = (event: React.MouseEvent) => {
    const target = event.target as HTMLElement;
    target.classList.toggle('ativo');
  };

  // Filtrar e ordenar features
  const featuresFiltered = NavigatorMap.filterAndSortFeatures(account);

  // Validar props na inicialização
  useEffect(() => {
    NavigatorService.validateNavigatorProps(account, {name: 'user'}); // Simplified validation
  }, [account]);

  return {
    activeItem,
    featuresFiltered,
    pathName,
    openSubmenu,
    toggleAtivoClass,
    setActiveItem,
    hasTheme,
  };
}
